import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FaRocket, FaBrain, FaUsers } from 'react-icons/fa';
import './Hero.css';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-section">
      <div className="container">
        <motion.div 
          className="hero-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <motion.div 
            className="hero-badge"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            🚀 Plataforma de Evaluación Integral
          </motion.div>

          <motion.h1 
            className="hero-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Descubre tu <span className="text-gradient">Potencial</span> y 
            <br />
            <span className="text-gradient-accent">Transforma</span> tu Futuro
          </motion.h1>

          <motion.p 
            className="hero-description"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            Conoce tus habilidades únicas y desarrolla tu espíritu emprendedor 
            con nuestras evaluaciones científicamente diseñadas.
          </motion.p>

          <motion.div 
            className="hero-actions"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <button 
              className="btn btn-primary"
              onClick={() => navigate('/test/inteligencias')}
            >
              <FaBrain /> Test de Inteligencias
            </button>
            <button 
              className="btn btn-secondary"
              onClick={() => navigate('/test/emprendedor')}
            >
              <FaRocket /> Test Emprendedor
            </button>
            {/* ===== NUEVO BOTÓN PARA LIDERAZGO ===== */}
            <button 
              className="btn btn-primary"
              onClick={() => navigate('/test/liderazgo')}
            >
              <FaUsers /> Test de Liderazgo
            </button>
          </motion.div>

          <motion.div 
            className="hero-stats"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1 }}
          >
            <div className="stat-item">
              <span className="stat-number">3</span> {/* ← Cambiado de 2 a 3 */}
              <span className="stat-label">Tests Disponibles</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-number">108</span> {/* ← Puedes cambiarlo a 108 si quieres */}
              <span className="stat-label">Preguntas Total</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-number">100%</span>
              <span className="stat-label">Resultados Gratuitos</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;